import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const PlayPauseIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      sx={{ width: props.width ?? "73px", height: props.height ?? "72px" }}
    >
      <svg
        {...props}
        viewBox="0 0 73 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_1593_23477"
          // style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="73"
          height="72"
        >
          <rect x="0.5" width="72" height="72" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_1593_23477)">
          <path
            d="M7.73486 50.1208V22.0531L28.2444 36.087L7.73486 50.1208ZM43.138 51.254V20.9199H47.5634V51.254H43.138ZM60.8396 51.254V20.9199H65.265V51.254H60.8396Z"
            fill="#7BBC7B"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
